export const MY_HOME_REDESIGN_EXPERIMENT = 'myhome_redesign_main_web';

export const EXPERIMENTS_NAMES = [MY_HOME_REDESIGN_EXPERIMENT];
